<template>
  <div>
    <!--左边导航栏-->
    <el-menu
        :router="true"
        default-active="0"
        class="bc-menu"
        background-color="#02152b"
        text-color="#fff"
        active-text-color="#ffd04b">
      <header class="bc-menu-header">
        <el-image style="position: absolute;top: 18px;left: 25px" :src="image.logo"></el-image>
        <div style="position: absolute;top: 21px;left: 67px;font-size: 18px;color: white">
          灰度发布
        </div>
      </header>
      <el-menu-item v-for="(item,index) in menuList" :key="index" :index="index.toString()" :route="item.route">
        <i :class="item.icon"></i>
        <span slot="title">{{ item.title }}</span>
      </el-menu-item>
    </el-menu>

    <!--上边导航栏-->
    <div class="bc-header">
      <div style="padding: 12px 16px 12px 0;position: absolute;right: 0">
        <div v-if="hasLogin">
          <span style="display: inline-block;margin-right: 20px">{{ nickname }}</span>
          <router-link to="/logout"><span>退出</span></router-link>
        </div>
        <div v-if="!hasLogin">
          <router-link to="/login">登陆</router-link>
        </div>
      </div>
    </div>

    <router-view style="min-width: 100vm;min-height: 100vh;padding-left: 200px;padding-top: 44px;background: #f2f2f2">

    </router-view>
  </div>
</template>

<script>
export default {
  name: "Layout",
  mounted() {
  },
  data() {
    return {
      image: {
        logo: require("@/assets/灰度发布.png")
      }
    }
  },
  computed: {
    nickname() {
      return this.$store.state.user.nickname;
    },
    hasLogin() {
      return this.$store.state.hasLogin;
    },
    menuList() {
      if (this.$store.state.user.isAdmin) {
        return [
          {title:'用户权限',route: {name: 'manage users'},icon:'el-icon-document'},
        ]
      } else {
        return [
          {title:'应用管理',route: {name: 'manage apps'},icon:'el-icon-menu'},
        ]
      }
    }
  }
}
</script>

<style scoped>
.bc-menu {
  width: 200px;
  height: 100vh;
  position: fixed;
  z-index: 10;
}

.bc-menu-header {
  width: 100%;
  height: 60px;
}

.bc-menu-header-text {
  color: rgba(255, 255, 255, 100);
  font-size: 18px;
  font-family: PangMenZhengDao;
  text-align: center;
  padding-top: 21px;
}

.bc-header {
  z-index: 9;
  width: 100%;
  height: 44px;
  padding-left: 200px;
  position: fixed;
  right: 0;
  top: 0;
  background: #ffffff;
  color: rgba(48, 49, 51, 100);
  font-size: 14px;
}

</style>
